import script from "./StepSetupTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSetupTracker.vue?vue&type=script&setup=true&lang=js"

import "./StepSetupTracker.vue?vue&type=style&index=0&id=71c63123&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c63123"]])

export default __exports__